module.exports = __webpack_public_path__ + "static/media/delettable.76fe4290.svg";